import React from 'react';

import { ProdStackManagerEmailConfirm } from 'containers/ProdStackManager/ProdStackManagerEmailConfirm';
import { ProdStackManagerClientInfoForm } from 'containers/ProdStackManager/ProdStackManagerClientInfoForm';
import { ProdStackManagerPhoneConfirm } from 'containers/ProdStackManager/ProdStackManagerPhoneConfirm';
import { useAppState } from 'hooks/useAppState';
import { useAppDispatcher } from 'hooks/useAppDispatcher';
import { ProdStackManagerFinish } from 'containers/ProdStackManager/ProdStackManagerFinish';
import { FadeAnimationComponent } from 'design/fadeAnimationComponents';
import { useProdStackManagerDataProcess } from 'hooks/useProdStackManagerDataProcess';
import { AsyncBoundaryComponent } from 'utils/asyncBoundary/asyncBoundaryComponents';
import { ProdStackLoadingFallback } from './ProdStackLoadingFallback';

export const ProdStackManagerContentAuthorized = () => {
  useProdStackManagerDataProcess();

  const { prodStackManagerCurrentStep: currentStep } = useAppState();

  const dispatch = useAppDispatcher();

  const handleStepSubmitSucceed = React.useCallback(() => {
    dispatch({
      name: 'ProdStackManager__StepSubmitSucceed',
    });
  }, [dispatch]);

  const content = React.useMemo(() => {
    if (currentStep === 0) {
      return (
        <ProdStackManagerEmailConfirm
          onSubmitSucceed={handleStepSubmitSucceed}
        />
      );
    }

    if (currentStep === 1) {
      return (
        <ProdStackManagerPhoneConfirm
          onSubmitSucceed={handleStepSubmitSucceed}
        />
      );
    }

    if (currentStep === 2) {
      // Оборачиваем форму в локальный AsyncBoundaryComponent
      // для отображения кастомного fallback при submit
      return (
        <AsyncBoundaryComponent fallback={<ProdStackLoadingFallback />}>
          <ProdStackManagerClientInfoForm
            onSubmitSucceed={handleStepSubmitSucceed}
          />
        </AsyncBoundaryComponent>
      );
    }

    return null;
  }, [currentStep, handleStepSubmitSucceed]);

  // Шаг 3 (Finish) имеет свою внутреннюю анимацию, поэтому выносим его за FadeAnimationComponent
  if (currentStep === 3) {
    return (
      <AsyncBoundaryComponent fallback={<ProdStackLoadingFallback />}>
        <ProdStackManagerFinish />
      </AsyncBoundaryComponent>
    );
  }

  return (
    <FadeAnimationComponent trigger={currentStep}>
      {content}
    </FadeAnimationComponent>
  );
};
